import { isFunction } from '@agilepoint/utils-common';
import { useMemo } from 'react';

export class KeyStrokeListener {
    private listeners = new Map<string, (event: KeyboardEvent) => void>();
    private isListenerInitialized = false;

    constructor(private elementRef: React.RefObject<HTMLElement>) { }

    public subscribe = (listener: (event: KeyboardEvent) => void, ...keyStrokes: string[]) => {
        keyStrokes.forEach((key) => {
            this.listeners.set(key, listener);
        });
        if (this.isListenerInitialized) {
            return;
        }
        this.elementRef.current?.addEventListener('keydown', this.handler);
        this.isListenerInitialized = true;
    }

    public unsubscribe = () => {
        this.listeners.clear();
        this.isListenerInitialized = false;
        this.elementRef.current?.removeEventListener('keydown', this.handler);
    }

    private handler = (event: KeyboardEvent) => {
        const listener = this.listeners.get(event.key);
        const keys = Array.from(this.listeners.keys());
        if (!keys.includes(event.key) || !isFunction(listener)) {
            return;
        }
        listener(event);
    }
}

export function useKeyStrokeListener(elementRef: React.RefObject<HTMLElement>) {
    const { subscribe, unsubscribe } = useMemo(() => new KeyStrokeListener(elementRef), [elementRef]);
    return { subscribe, unsubscribe };
}
